import { SendTextProps } from './index';
import { Step } from 'pages/AutomationEngine/types';
import { CreateAutomationMessageProps } from './types';

type ForApiReturn = {
  text: { id: string };
};

const forApi = (step: Step & { details: SendTextProps['values'] }) => {
  const orgDetails = { ...step.details };
  const api: ForApiReturn = {
    text: { id: orgDetails?.textObject?.id! },
  };
  return { details: api };
};

const forFlow = (apiObject: CreateAutomationMessageProps) => {
  // text details moved to object textObject because of field name clashes
  return { textObject: apiObject };
};
export const sendTextDTO = {
  forApi,
  forFlow,
};
